<template>
    <div class="upcoming-classes">
        <h2 class="intro" id="upcoming-classes">Upcoming Classes</h2>
        <div v-if="!events.length" class="text-center w-100 text-muted mb-5">
            There are not classes in the calendar right now, check again later.
        </div>
        <div v-else class="card card-default">
            <table class="table table-hover clickleable table-sm" aria-label="Upcoming Classes" aria-describedby="upcoming-classes">
                <thead>
                <tr>
                    <th>Class</th>
                    <th class="d-none d-md-table-cell">Location</th>
                    <th class="d-none d-sm-table-cell">Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="event in events" :key="event.id" @click="open(event)">
                    <td>
                        <span v-text="event.course.title"></span>
                        <span class="badge badge-success badge-free" v-if="event.course.is_free">FREE</span>
                    </td>
                    <td class="d-none d-md-table-cell" v-text="event.location"></td>
                    <td class="d-none d-sm-table-cell" v-text="shortDate(event.date)"></td>
                </tr>
                </tbody>
            </table>
        </div>
        <p v-if="events.length">
            <a href="/calendar">
                Full calendar of classes
            </a>
        </p>
    </div>
</template>
<script>
    export default {

        props: {
            events: {
                type: Array,
                required: true,
            }
        },

        methods: {
            open(event) {
                this.redirectTo(`courses/${event.course.slug}?date=${event.id}`)
            }
        }
    }
</script>